import { QueryClient } from '@tanstack/react-query';
import queryErrorHandler from './query_error_handler';

const generateQueryClient = (): QueryClient => {
  return new QueryClient({
    defaultOptions: {
      queries: {
        staleTime: 1000,
        suspense: false,
        onError: queryErrorHandler,
        refetchOnWindowFocus: false, // window focus 시 refetch 하지 않음
      },
      mutations: {
        onError: queryErrorHandler,
      },
    },
  });
};

export const queryClient = generateQueryClient();
